import React, { useState } from 'react';
import Dashboard from './Dashboard';
import '../css/Templates.css';

const Templates = () => {
  const [qrCount, setQrCount] = useState(0);
  const [urlCount, setUrlCount] = useState(0);
  const [phoneCount, setPhoneCount] = useState(0);
  const [codeCount, setCodeCount] = useState(0);
  
  const [quickReplies, setQuickReplies] = useState([]);
  const [urls, setUrls] = useState([]);
  const [phones, setPhones] = useState([]);
  const [codes, setCodes] = useState([]);
  
  const qrLimit = 10;
  const urlLimit = 2;
  const phoneLimit = 1;
  const codeLimit = 1;

  const handleAddQuickReply = () => {
    if (qrCount < qrLimit) {
      setQuickReplies([...quickReplies, `Quick Reply ${qrCount + 1}`]);
      setQrCount(qrCount + 1);
    }
  };

  const handleAddUrl = () => {
    if (urlCount < urlLimit) {
      setUrls([...urls, `URL ${urlCount + 1}`]);
      setUrlCount(urlCount + 1);
    }
  };

  const handleAddPhone = () => {
    if (phoneCount < phoneLimit) {
      setPhones([...phones, 'Phone Number']);
      setPhoneCount(phoneCount + 1);
    }
  };

  const handleAddCode = () => {
    if (codeCount < codeLimit) {
      setCodes([...codes, 'Copy Code']);
      setCodeCount(codeCount + 1);
    }
  };

  return (
    <div className="templates-container mx-5 mt-5 pt-5">
      <Dashboard />
      <div className="content-area bg-light mt-5">
      <h2>Templates</h2>
        <div className="container py-3">
          <div className="row g-4">
            {/* Left Form */}
            <div className="col-lg-6">
              <form>
                <div className="mb-3">
                  <label className="form-label fw-bold">Template Category</label><br />
                  <small>Your template should fall under one of these categories</small>
                  <select className="form-select">
                    <option>Select message categories</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Template Name</label><br />
                  <small className="text-muted">Name can only be in lowercase alphanumeric characters and underscores. Special characters and white-space are not allowed<br />e.g: app_verification_code.</small>
                  <input type="text" className="form-control" placeholder="Enter name" />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Template Type</label><br />
                  <small>Your template type should fall under one of these categories</small>
                  <select className="form-select">
                    <option>Select message type</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Template Format</label><br />
                  <small className="text-muted">Use text formatting *bold*, _italic_, ~strikethrough~.<br /> your message content Max 1024 characters are allowed<br />
                    e.g: Hello{"{(1)}"}. your code will expire in {"{(2)}"} mins</small>
                  <textarea className="form-control" rows="4" maxLength="1024" placeholder="Enter your message in here..."></textarea>
                  <small className="text-muted">Use *bold*, _italic_, ~strikethrough~. Max 1024 characters.</small>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Template Footer (Optional)</label>
                  <small className="text-muted">Up to 60 characters allowed.</small>
                  <input type="text" className="form-control" placeholder="Enter footer text here" maxLength="60" />
                </div>
              </form>
            </div>

            {/* Right Preview */}
            <div className="col-lg-6 position-relative">
              <div className="mb-3">
                <label className="form-label fw-bold">Template Language</label>
                <small>You will need to specify the Language in which message template is submitted</small>
                <select className="form-select">
                  <option>Select message categories</option>
                </select>
              </div>
              <h5>Template Preview</h5>
              <p className="text-muted">Your template message preview. It will update as you fill in the values in the form.</p>
              
              <div className="preview-box position-relative">
                <img src="https://img.icons8.com/color/48/whatsapp--v1.png" alt="whatsapp" className="whatsapp-icon" />
                
                <div className="media-icons">
                  <img src="https://img.icons8.com/color/48/image.png" alt="image" />
                  <img src="https://img.icons8.com/color/48/play-button-circled--v1.png" alt="video" />
                  <img src="https://img.icons8.com/color/48/document.png" alt="doc" />
                </div>
                <div className="disclaimer">
                  Disclaimer: This is just a graphical representation of the message that will be delivered. Actual message will consist of media selected and may appear different.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row mb-3">
            <div className="col-lg-8">
              <h6>Interactive Actions</h6>
              <p className="text-muted small">
                In addition to your message, you can send actions with your message.<br />
                Max 25 characters are allowed in CTA button title & Quick Replies.
              </p>

              {/* Action Buttons */}
              <div className="mb-4 d-flex flex-wrap align-items-start">
                <div className={`action-pill ${qrCount === qrLimit ? 'disabled' : ''}`} onClick={handleAddQuickReply}>
                  + Quick Replies <span className="badge">{qrCount}</span>
                </div>
                <div className={`action-pill ${urlCount === urlLimit ? 'disabled' : ''}`} onClick={handleAddUrl}>
                  + URL <span className="badge">{urlCount}</span>
                </div>
                <div className={`action-pill ${phoneCount === phoneLimit ? 'disabled' : ''}`} onClick={handleAddPhone}>
                  + Phone Number <span className="badge">{phoneCount}</span>
                </div>
                <div className={`action-pill ${codeCount === codeLimit ? 'disabled' : ''}`} onClick={handleAddCode}>
                  + Copy Code <span className="badge">{codeCount}</span>
                </div>
              </div>

              {/* Dynamic Inputs */}
              <div id="quickRepliesBox">
                {quickReplies.map((placeholder, index) => (
                  <input 
                    key={`qr-${index}`} 
                    className="form-control" 
                    placeholder={placeholder}
                    maxLength={25}
                  />
                ))}
              </div>
              
              <div id="urlBox">
                {urls.map((placeholder, index) => (
                  <input 
                    key={`url-${index}`} 
                    className="form-control" 
                    placeholder={placeholder}
                    type="url"
                  />
                ))}
              </div>
              
              <div id="phoneBox">
                {phones.map((placeholder, index) => (
                  <input 
                    key={`phone-${index}`} 
                    className="form-control" 
                    placeholder={placeholder}
                    type="tel"
                  />
                ))}
              </div>
              
              <div id="codeBox">
                {codes.map((placeholder, index) => (
                  <input 
                    key={`code-${index}`} 
                    className="form-control" 
                    placeholder={placeholder}
                  />
                ))}
              </div>

              {/* Submit */}
              <button className="btn btn-submit">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Templates; 